import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIVATE_API } from "../../api/apiIndex";

const initialState = {
  data: null,
  error: "",
  status: "idle",
  addStatus: "idle",
  question: null,
  getStatus: "idle",
  updateStatus: "idle",
};

export const fetchQuestions = createAsyncThunk(
  "questions/fetchQuestions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get("/question");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const addQuestion = createAsyncThunk(
  "questions/addQuestion",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.post("/question/create", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.reponse.data : error);
    }
  }
);

export const getQuestion = createAsyncThunk(
  "questions/getQuestion",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get(`/question/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.reponse.data : error);
    }
  }
);

export const updateQuestion = createAsyncThunk(
  "questions/updateQuestion",
  async (userData, { rejectWithValue }) => {
    try {
      const { id, data } = userData;
      const response = await PRIVATE_API.put(`/question/${id}`, data);
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

export const deleteQuestion = createAsyncThunk(
  "questions/deleteQuestion",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.delete(`/question/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.reponse.data : error);
    }
  }
);

const questionSlice = createSlice({
  name: "questions",
  initialState,
  reducers: {
    setIdleStatus: (state) => {
      state.addStatus = "idle";
    },
    clearQuestion: (state) => {
      state.question = null;
      state.error = "";
      state.getStatus = "idle";
      state.updateStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    // fetch question
    builder
      .addCase(fetchQuestions.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchQuestions.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.data = action.payload.data;
      })
      .addCase(fetchQuestions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      })

      //   Add Question
      .addCase(addQuestion.pending, (state, action) => {
        state.addStatus = "loading";
        state.error = "";
      })
      .addCase(addQuestion.fulfilled, (state, action) => {
        state.addStatus = "success";
        state.error = "";
        state.data = [action.payload.data, ...state.data];
        // console.log(action.payload);
      })
      .addCase(addQuestion.rejected, (state, action) => {
        state.addStatus = "failed";
        state.error = action.payload.message;
      })

      // Get a question
      .addCase(getQuestion.pending, (state, action) => {
        state.getStatus = "loading";
        state.error = "";
      })
      .addCase(getQuestion.fulfilled, (state, action) => {
        state.error = "";
        state.question = action.payload.data;
        state.getStatus = "success";
      })
      .addCase(getQuestion.rejected, (state, action) => {
        state.getStatus = "failed";
        state.error = action.payload.message;
      })

      // Update Question
      .addCase(updateQuestion.pending, (state, action) => {
        state.updateStatus = "loading";
        state.error = "";
      })
      .addCase(updateQuestion.fulfilled, (state, action) => {
        state.updateStatus = "success";
        state.error = "";
        // state.data = action.payload.data;
        state.data = state.data?.map((question) =>
          question?._id === action?.payload?.data?._id
            ? action.payload.data
            : question
        );
      })
      .addCase(updateQuestion.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.error = action.payload.message;
        // console.log(action);
      })

      // Delete question
      .addCase(deleteQuestion.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(deleteQuestion.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.data = state.data.filter(
          (question) => question._id !== action.payload.data
        );
      })
      .addCase(deleteQuestion.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      });
  },
});

export const { setIdleStatus, clearQuestion } = questionSlice.actions;

export const getQuestions = (state) => state.questions.data;
export const getQuestionStatus = (state) => state.questions.status;

export const getAddQuestionStatus = (state) => state.questions.addStatus;

export const getAQuestion = (state) => state.questions.question;
export const getGetQuestionStatus = (state) => state.questions.getStatus;

export const getUpdateQuestionStatus = (state) => state.questions.updateStatus;

export const getQuestionError = (state) => state.questions.error;

export default questionSlice.reducer;
